// Swym Wishlist Fix for Product Recommendations
(function() {
  'use strict';
  
  // Function to initialize Swym buttons
  function initSwymButtons() {
    // Method 1: Direct _swat call
    if (window._swat && typeof window._swat.initializeActionButtons === 'function') {
      try {
        window._swat.initializeActionButtons();
        window._swat.initializeActionButtons("body");
      } catch (e) {
        console.log('Swym direct init failed:', e);
      }
    }
    
    // Method 2: SwymCallbacks approach
    if (window.SwymCallbacks && Array.isArray(window.SwymCallbacks)) {
      window.SwymCallbacks.push(function(swat) {
        try {
          swat.initializeActionButtons();
          swat.initializeActionButtons("body");
        } catch (e) {
          console.log('Swym callback init failed:', e);
        }
      });
    }
    
    // Method 3: Manual button activation
    const swymButtons = document.querySelectorAll('.swym-button, .swym-add-to-wishlist-view-product');
    swymButtons.forEach(button => {
      if (!button.classList.contains('swym-initialized')) {
        button.classList.add('swym-initialized');
        
        // Trigger Swym's button initialization manually
        if (window._swat && window._swat.initializeButton) {
          try {
            window._swat.initializeButton(button);
          } catch (e) {
            console.log('Manual button init failed:', e);
          }
        }
      }
    });
  }
  
  // Listen for product recommendations loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Observer for product recommendations container
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Check if product recommendations were added
          const hasProductCards = Array.from(mutation.addedNodes).some(node => 
            node.nodeType === 1 && (
              node.querySelector && (
                node.querySelector('.swym-button') || 
                node.querySelector('.swym-add-to-wishlist-view-product') ||
                node.classList.contains('card--product')
              )
            )
          );
          
          if (hasProductCards) {
            console.log('Product recommendations detected, initializing Swym...');
            setTimeout(initSwymButtons, 100);
            setTimeout(initSwymButtons, 500);
            setTimeout(initSwymButtons, 1000);
          }
        }
      });
    });
    
    // Start observing
    const recommendationsContainer = document.querySelector('product-recommendations');
    if (recommendationsContainer) {
      observer.observe(recommendationsContainer, {
        childList: true,
        subtree: true
      });
    }
    
    // Also observe the entire body for safety
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
  
  // Custom event listener
  document.addEventListener('swym:product-recommendations-loaded', function() {
    console.log('Custom Swym event triggered');
    initSwymButtons();
  });
  
})();